"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRmaSolid = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconRmaSolid = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M24 24h-1.406c0-6.334-5.152-11.487-11.485-11.487h-.234v5.48L0 8.995 10.875 0v5.497C18.169 5.861 24 11.884 24 19.313V24z",
  fillRule: "evenodd"
}));
exports.IconRmaSolid = IconRmaSolid;
//# sourceMappingURL=IconRmaSolid.js.map